// extracted by mini-css-extract-plugin
export var avatar = "_pu-3";
export var avatarContainer = "_pu-2";
export var avatarSpacer = "_pu-5";
export var avatarSpacerContainer = "_pu-4";
export var avatarStackContainer = "_pu-1";
export var bubble = "_pu-0";
export var remainderBubble = "_pu-6";